export default __webpack_public_path__ + "static/media/filter_alt.fb9962a1.svg";